/* eslint-disable no-unused-vars */
import { Grid, Typography, Card } from "@mui/material";
import PDialog from "../../../components/pos/PDialog";
import PText from "../../../components/pos/PText";
import db from "../../../db/db";
import { useTranslation } from "react-i18next";
import API from "../../../utils/API";
import { PricingUtils } from "../../../utils/PricingUtils";
import { useEffect, useState } from "react";
import PDigitPanel from "../../../components/pos/PDigitPanel";
import { add } from "date-fns";

export const DayCloseDataEntry = (props) => {
  const { t } = useTranslation();
  const translate = t;
  props.biRef.dayCloseDataEntryWindow = {
    parentEvent: parentEvent,
  };
  const [openWindow, setOpenWindow] = useState(true);

  const [amount, setAmount] = useState("0");
  const [amountError, setAmountError] = useState("");
  const [isActiveHoldSaleExists, setIsActiveHoldSaleExists] = useState(false);
  const [isPendingSyncExists, setIsPendingSyncExists] = useState(false);
  const [currencyConfig, setCurrencyConfig] = useState({
    notes: [],
    coins: [],
  });
  const [currentFocus, setCurrentFocus] = useState("");

  const [noteValues, setNoteValues] = useState([]);
  const [coinValues, setCoinValues] = useState([]);

  const [noteCount, setNoteCount] = useState([]);
  const [coinCount, setCoinCount] = useState([]);
  const [coinTotal, setCoinTotal] = useState("0.00");
  const [noteTotal, setNoteTotal] = useState("0.00");
  const [saveInProgress, setSaveInProgress] = useState(false);
  const [exRateFound, setExRateFound] = useState(false);

  const [payCodeArr, setPayCodeArr] = useState([]);
  function onCloseWindow() {
    props.setShowDayCloseDataEntry(false);
  }

  useEffect(() => {
    checkActiveHoldSales();
    getPendingSaleSyncRequest();
    initScreen();
  }, []);

  useEffect(() => {
    if (props.context.saleSetting.denominationInDayClose)
      calculateTotal(noteCount, coinCount);
  }, [noteCount, coinCount]);

  async function initScreen() {
    if (props.context.saleSetting.denominationInDayClose) {
      let dbData = await db.config
        .where("name")
        .equals("CURRENCY_CONFIG")
        .toArray();
      console.log(
        JSON.parse(dbData[0].configTxt)[props.context.store.currency]
      );
      let config = JSON.parse(dbData[0].configTxt)[
        props.context.store.currency
      ];
      setCurrencyConfig(config);

      setNoteCount(Array(config.notes.length).fill(""));
      setCoinCount(Array(config.coins.length).fill(""));
    } else {
      let dbData = await db.config.where("name").equals("PAY_CODES").toArray();
      let paycodes = JSON.parse(dbData[0].configTxt);
      let arr = [];

      let fxData = await db.fxrate.toArray();

      arr.push({
        code: props.context.store.currency,
        srcAmount: "",
        exRate: "1.00",
        amount: "0.00",
      });
      for (let d of paycodes.SALE) {
        if (d.isFx) {
          arr.push({
            code: d.code,
            srcAmount: "",
            amount: "0.00",
            exRate: getExRate(fxData, d.code),
          });
          setExRateFound(true);
        }
      }
      setAmount(deriveTotal(arr));
      setPayCodeArr(arr);
    }
  }

  function deriveTotal(arr) {
    let tot = 0;
    for (let c of arr) {
      tot = tot + parseFloat(c.amount);
    }
    return PricingUtils.formattedNumber(
      tot,
      props.context.store.currencyDecimal
    );
  }

  function getExRate(fxData, code) {
    for (let fx of fxData) {
      if (fx.sourceCurrencyCode == code) {
        return fx.conversionRate;
      }
    }
    return 1;
  }

  function parentEvent(event, value) {
    console.log(event + value);
    if ("openWindow" === event) {
      setSaveInProgress(false);
      setOpenWindow(value);
      //setAmount("");
      console.log(event + value);
    }
  }

  async function onSave() {
    if (validateDayclose()) {
      setSaveInProgress(true);
      let json = localStorage.getItem("terminal");
      let j = JSON.parse(json);
      let amt = "0.00";
      if (parseFloat(amount) > 0) {
        amt = amount;
      }
      let v = [];
      if (exRateFound) {
        let vArr = [];
        for (let a of payCodeArr) {
          if (!a.srcAmount) {
            a.srcAmount = "0";
          }
          if (parseFloat(a.amount) > 0) {
            vArr.push(a);
          }
        }
        v = vArr;
      } else {
        v.push({ amount: amt, exRate: 1, srcAmount: amt, code: "CASH" });
      }
      if (v.length == 0) {
        v.push({ amount: 0, exRate: 1, srcAmount: 0, code: "CASH" });
      }
      PricingUtils.formattedNumber(amt, props.context.store.currencyDecimal);
      try {
        let payload = {
          saleSessionId: props.saleSession ? props.saleSession.id : null,
          amount: amt,
          shiftMode: props.shiftMode,
          notes: getDenominationInfo(noteCount, noteValues, "notes"),
          coins: getDenominationInfo(coinCount, coinValues, "coins"),
          closeCurrency: v,
          coinTotal: coinTotal,
          noteTotal: noteTotal,
        };
        console.log(payload);

        let { data } = await API.post(
          "/api/v1/salesession/close_data_entry",
          payload
        );

        await props.checkSaleFlow();

        onCloseWindow();
        props.setShowDayCloseSummary(true);
        setSaveInProgress(false);
      } catch (err) {
        setSaveInProgress(false);
        console.log(err);
        if (err.response.data) props.showMessage("error", err.response.data);
      }
    }
  }

  function getDenominationInfo(pCountVals, pValues, key) {
    let res = [];
    if (props.context.saleSetting.denominationInDayClose) {
      let ix = 0;
      for (let count of pCountVals) {
        console.log(count);
        if (count && !isNaN(count) && parseInt(count) > 0) {
          let obj = {
            netAmount: pValues[ix],
            faceValue: currencyConfig[key][ix].faceValue,
            dValue: currencyConfig[key][ix].value,
            count: count,
            name: currencyConfig[key][ix].name,
          };
          res.push(obj);
        }
        ix++;
      }
    }
    return res;
  }

  function validateDayclose() {
    if (isActiveHoldSaleExists) {
      console.log("hold if and value", isActiveHoldSaleExists);
      props.showMessage(
        "error",
        "Can't proceed day close with active hold sale!"
      );
      return false;
    } else if (isPendingSyncExists) {
      console.log("hold elseif and value", isPendingSyncExists);
      props.showMessage(
        "error",
        "Can't proceed day close when pending SYNC exists"
      );
      return false;
    } else {
      return true;
    }
  }

  async function getPendingSaleSyncRequest() {
    let syncMeta = await db.sync_meta.count();
    if (syncMeta > 0) setIsPendingSyncExists(true);
    else setIsPendingSyncExists(false);
  }

  async function checkActiveHoldSales() {
    console.log("hello from dayclose");
    let val = await db.setting.where("sKey").equals("sale").toArray();

    let saleSettings = JSON.parse(val[0].sValue);
    console.log("saleSettings", saleSettings);
    if (!saleSettings.allowHoldInvoice) {
      console.log("hello from if part");
      getActiveHoldSales();
    } else {
      console.log("hello from else part");
      setIsActiveHoldSaleExists(false);
    }
  }

  async function getActiveHoldSales() {
    try {
      let curPage = 0;
      let pageSize = 6;
      let sort = '[{id:"date",sortOrder:"DESC"}]';
      let filter = "[]";
      const saleHoldResult = await API.get(
        "/api/v1/hold/list?range=" +
          encodeURIComponent(
            "[" +
              curPage * pageSize +
              "," +
              ((curPage + 1) * pageSize - 1) +
              "]"
          ) +
          "&filter=" +
          encodeURIComponent(filter) +
          "&sort=" +
          encodeURIComponent(sort) +
          "&searchType=" +
          encodeURIComponent("SALE")
      );

      const salesReturnHoldResult = await API.get(
        "/api/v1/hold/list?range=" +
          encodeURIComponent(
            "[" +
              curPage * pageSize +
              "," +
              ((curPage + 1) * pageSize - 1) +
              "]"
          ) +
          "&filter=" +
          encodeURIComponent(filter) +
          "&sort=" +
          encodeURIComponent(sort) +
          "&searchType=" +
          encodeURIComponent("SALE_RETURN")
      );

      const salesOrderHoldResult = await API.get(
        "/api/v1/hold/list?range=" +
          encodeURIComponent(
            "[" +
              curPage * pageSize +
              "," +
              ((curPage + 1) * pageSize - 1) +
              "]"
          ) +
          "&filter=" +
          encodeURIComponent(filter) +
          "&sort=" +
          encodeURIComponent(sort) +
          "&searchType=" +
          encodeURIComponent("sale_order")
      );

      const serviceOrderHoldResult = await API.get(
        "/api/v1/hold/list?range=" +
          encodeURIComponent(
            "[" +
              curPage * pageSize +
              "," +
              ((curPage + 1) * pageSize - 1) +
              "]"
          ) +
          "&filter=" +
          encodeURIComponent(filter) +
          "&sort=" +
          encodeURIComponent(sort) +
          "&searchType=" +
          encodeURIComponent("service")
      );

      console.log("service", serviceOrderHoldResult);
      console.log("sale order", salesOrderHoldResult);

      if (
        saleHoldResult.data.data.length > 0 ||
        salesReturnHoldResult.data.data.length > 0 ||
        serviceOrderHoldResult.data.data.length > 0 ||
        salesOrderHoldResult.data.data.length > 0
      ) {
        setIsActiveHoldSaleExists(true);
      } else {
        setIsActiveHoldSaleExists(false);
      }
    } catch (err) {
      if (err.response.data)
        props.showMessage("error", "Error while validate active hold sales!");
      return setIsActiveHoldSaleExists(false);
    }
  }

  function calculateTotal(nCounts, cCounts) {
    let total = 0;
    let nTotal = 0;
    let cTotal = 0;

    let ix = 0;
    let nValues = [];
    let cValues = [];
    for (let note of nCounts) {
      if (!isNaN(note)) {
        total = total + note * currencyConfig.notes[ix].value;
        nTotal = nTotal + note * currencyConfig.notes[ix].value;
        nValues.push(
          PricingUtils.formattedNumber(
            note * currencyConfig.notes[ix].value,
            props.context.store.currencyDecimal
          )
        );
      } else {
        nValues.push(
          PricingUtils.formattedNumber(0, props.context.store.currencyDecimal)
        );
      }
      ix++;
    }
    ix = 0;
    for (let coin of cCounts) {
      if (!isNaN(coin)) {
        total = total + coin * currencyConfig.coins[ix].value;
        cTotal = cTotal + coin * currencyConfig.coins[ix].value;

        cValues.push(
          PricingUtils.formattedNumber(
            coin * currencyConfig.coins[ix].value,
            props.context.store.currencyDecimal
          )
        );
      } else {
        cValues.push(
          PricingUtils.formattedNumber(0, props.context.store.currencyDecimal)
        );
      }
      ix++;
    }
    setNoteValues(nValues);
    setCoinValues(cValues);
    setCoinTotal(
      PricingUtils.formattedNumber(cTotal, props.context.store.currencyDecimal)
    );
    setNoteTotal(
      PricingUtils.formattedNumber(nTotal, props.context.store.currencyDecimal)
    );
    setAmount(
      PricingUtils.formattedNumber(total, props.context.store.currencyDecimal)
    );
  }

  function changeSrcAmount(index, value) {
    let arr = [...payCodeArr];
    arr[index]["srcAmount"] = value;
    arr[index]["amount"] = PricingUtils.formattedNumber(
      parseFloat(arr[index]["srcAmount"] ? arr[index]["srcAmount"] : "0") *
        parseFloat(arr[index]["exRate"]),
      props.context.store.currencyDecimal
    );
    setAmount(deriveTotal(arr));
    setPayCodeArr(arr);
  }
  function changeSrcAmountError(index, value) {
    let a = [...payCodeArr];
    a[index]["srcAmountEror"] = value;
    setPayCodeArr(a);
  }

  function onDelete() {}
  const exRateContent = (
    <Grid container>
      <Grid item xs={3}>
        Code
      </Grid>
      <Grid item xs={3}>
        Cash
      </Grid>
      <Grid item xs={3} sx={{ textAlign: "right" }}>
        Ex Rate
      </Grid>
      <Grid item xs={3} sx={{ textAlign: "right" }}>
        Amount
      </Grid>
      <Grid item xs={12}>
        {payCodeArr.map(function (node, index) {
          return (
            <Grid container style={{ paddingTop: "5px" }}>
              <Grid item xs={3}>
                {node.code}
              </Grid>
              <Grid item xs={3}>
                <PText
                  value={node.srcAmount}
                  autoFocus={index == 0 ? true : false}
                  type="number"
                  error={node.srcAmountError}
                  onFocus={(event) => {
                    setCurrentFocus("fx_" + index);
                  }}
                  onChange={(e) => {
                    if (!isNaN(index, e.target.value)) {
                      changeSrcAmount(index, e.target.value);
                      changeSrcAmountError(index, "");
                    }
                  }}
                ></PText>
              </Grid>
              <Grid item xs={3} sx={{ textAlign: "right" }}>
                {node.exRate}
              </Grid>
              <Grid item xs={3} sx={{ textAlign: "right" }}>
                {node.amount}
              </Grid>
            </Grid>
          );
        })}
      </Grid>

      <Grid xs={12} sx={{ pt: "10px" }}>
        <PDigitPanel onKeyPressed={onKeyPressed} />
      </Grid>
      <Grid item xs={6} sx={{ marginTop: "15px", fontSize: "1.5rem" }}>
        Total
      </Grid>
      <Grid
        item
        xs={6}
        sx={{ textAlign: "right", marginTop: "15px", fontSize: "1.5rem" }}
      >
        {amount} {props.context.store.currency}
      </Grid>
    </Grid>
  );
  function onKeyPressed(keyCode) {
    if (!exRateFound) {
      if (props.context.saleSetting.denominationInDayClose) {
        console.log("onKeyPressed");
        if (currentFocus.length > 0) {
          let [key, ix] = currentFocus.split("_");
          if (key === "notes") {
            let index = parseInt(ix);
            let nv = [...noteCount];
            let v = getValue(nv[index], keyCode);
            nv[index] = v;
            setNoteCount(nv);
          }
          if (key === "coins") {
            let index = parseInt(ix);
            let nv = [...coinCount];
            let v = getValue(nv[index], keyCode);
            nv[index] = v;
            setCoinCount(nv);
          }
        }
      } else {
        let v = getValue(amount, keyCode);
        setAmount(v);
      }
    } else {
      if (currentFocus.length > 0) {
        let [key, ix] = currentFocus.split("_");
        if (key === "fx") {
          let index = parseInt(ix);
          let py = [...payCodeArr];
          let v = getValue(py[index].srcAmount, keyCode);
          py[index].srcAmount = v;

          py[index]["amount"] = PricingUtils.formattedNumber(
            parseFloat(py[index]["srcAmount"] ? py[index]["srcAmount"] : "0") *
              parseFloat(py[index]["exRate"]),
            props.context.store.currencyDecimal
          );
          setAmount(deriveTotal(py));
          setPayCodeArr(py);
        }
      }
    }
  }

  function getValue(currentValue, key) {
    if ("Backspace" === key) {
      if (currentValue.length > 0) {
        return getSubStr(currentValue);
      }
      return currentValue;
    } else {
      if ("." === key) {
        if (currentValue.includes(".")) {
          return currentValue;
        }
      }
      return currentValue + key;
    }
  }

  function getSubStr(str) {
    let s = str.substring(0, str.length - 1);
    if (s.endsWith(".")) {
      s = s.substring(0, s.length - 1);
    }
    return s;
  }

  const denominatedScreen = (
    <div>
      <Grid container>
        <Grid item xs={12}>
          <Typography variant="h6" gutterBottom component="div">
            Cash In Hand
          </Typography>
        </Grid>
        <Grid item xs={4} sx={{ pl: "10px", pr: "5px" }}>
          <Card variant="outlined" sx={{ p: "5px" }}>
            <Grid container>
              <Grid item xs={12}>
                <Typography variant="h6" gutterBottom component="div">
                  Notes
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography variant="h7" gutterBottom component="div">
                  Banknote
                </Typography>
              </Grid>
              <Grid item xs={4} sx={{ textAlign: "right" }}>
                <Typography variant="h7" gutterBottom component="div">
                  Count
                </Typography>
              </Grid>
              <Grid item xs={4} sx={{ textAlign: "right" }}>
                <Typography variant="h7" gutterBottom component="div">
                  Amount
                </Typography>
              </Grid>
              <Grid item xs={12}>
                {currencyConfig.notes.map(function (note, index) {
                  return (
                    <Grid container>
                      <Grid item xs={4} sx={{ pt: "5px" }}>
                        {note.faceValue + " "}
                        {note.name} x
                      </Grid>
                      <Grid item xs={4} sx={{ p: "3px" }}>
                        <PText
                          value={noteCount[index]}
                          type="number"
                          onChange={(e) => {
                            let nv = [...noteCount];
                            nv[index] = e.target.value;
                            setNoteCount(nv);
                          }}
                          onFocus={(event) => {
                            setCurrentFocus("notes_" + index);
                          }}
                          sx={{
                            input: {
                              background:
                                currentFocus === "notes_" + index
                                  ? "#FFFACD	"
                                  : "white",
                            },
                          }}
                        ></PText>
                      </Grid>
                      <Grid item xs={4} sx={{ p: "3px", textAlign: "right" }}>
                        {noteValues[index]}
                      </Grid>
                    </Grid>
                  );
                })}
              </Grid>
              <Grid item xs={12}>
                <Grid container>
                  <Grid item xs={8} sx={{ textAlign: "right" }}>
                    <Typography variant="button" display="block" gutterBottom>
                      TOTAL
                    </Typography>
                  </Grid>
                  <Grid item xs={4} sx={{ textAlign: "right" }}>
                    <Typography variant="button" display="block" gutterBottom>
                      {noteTotal}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Card>
        </Grid>
        <Grid item xs={4} sx={{ pl: "5px", pr: "10px" }}>
          <Card variant="outlined" sx={{ p: "5px" }}>
            <Grid container>
              <Grid items xs={12}>
                <Typography variant="h6" gutterBottom component="div">
                  Coins
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography variant="h7" gutterBottom component="div">
                  Coin
                </Typography>
              </Grid>
              <Grid item xs={4} sx={{ textAlign: "right" }}>
                <Typography variant="h7" gutterBottom component="div">
                  Count
                </Typography>
              </Grid>
              <Grid item xs={4} sx={{ textAlign: "right" }}>
                <Typography variant="h7" gutterBottom component="div">
                  Amount
                </Typography>
              </Grid>
              <Grid item xs={12}>
                {currencyConfig.coins.map(function (coin, index) {
                  return (
                    <Grid container>
                      <Grid items xs={4} sx={{ pt: "5px" }}>
                        {coin.faceValue + " "}
                        {coin.name} x
                      </Grid>
                      <Grid items xs={4} sx={{ p: "3px" }}>
                        <PText
                          value={coinCount[index]}
                          type="number"
                          onChange={(e) => {
                            let nv = [...coinCount];
                            nv[index] = e.target.value;
                            setCoinCount(nv);
                          }}
                          onFocus={(event) => {
                            setCurrentFocus("coins_" + index);
                          }}
                          sx={{
                            input: {
                              background:
                                currentFocus === "coins_" + index
                                  ? "#FFFACD	"
                                  : "white",
                            },
                          }}
                        ></PText>
                      </Grid>
                      <Grid items xs={4} sx={{ textAlign: "right" }}>
                        {coinValues[index]}
                      </Grid>
                    </Grid>
                  );
                })}
              </Grid>
              <Grid item xs={12}>
                <Grid container>
                  <Grid item xs={8} sx={{ textAlign: "right" }}>
                    <Typography variant="button" display="block" gutterBottom>
                      TOTAL
                    </Typography>
                  </Grid>
                  <Grid item xs={4} sx={{ textAlign: "right" }}>
                    <Typography variant="button" display="block" gutterBottom>
                      {coinTotal}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Card>
        </Grid>

        <Grid item xs={4} sx={{ pt: "" }}>
          <Grid container>
            <Grid item xs={12}>
              <Card variant="outlined" sx={{ p: "5px" }}>
                <PDigitPanel onKeyPressed={onKeyPressed} disableDot={true} />
              </Card>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={10}>
          <Typography variant="h6" gutterBottom component="div">
            Amount : {amount}
          </Typography>
        </Grid>
      </Grid>
    </div>
  );

  const content = (
    <Grid container>
      <Grid item xs={6}>
        {translate("Cash in Hand")}
      </Grid>
      <Grid item xs={6}>
        <PText
          value={amount}
          autoFocus={true}
          //type="number"
          error={amountError}
          onChange={(e) => {
            if (!isNaN(e.target.value)) {
              setAmount(e.target.value);
              setAmountError("");
            }
          }}
        ></PText>
      </Grid>
      <Grid xs={12} sx={{ pt: "10px" }}>
        <PDigitPanel onKeyPressed={onKeyPressed} />
      </Grid>
    </Grid>
  );

  function getContent() {
    if (exRateFound) {
      return exRateContent;
    } else {
      return props.context.saleSetting.denominationInDayClose
        ? denominatedScreen
        : content;
    }
  }

  return (
    <div>
      {openWindow && (
        <PDialog
          content={getContent()}
          title={props.shiftMode ? "Shift Close" : "Day Close"}
          maxWidth={
            props.context.saleSetting.denominationInDayClose ? "xl" : "xs"
          }
          fullWidth={true}
          open={true}
          onCloseWindow={onCloseWindow}
          onSave={onSave}
          saveLabel="Proceed"
          mode={"create"}
          saveDisabled={saveInProgress}
          isSaveLoaderEnabled={saveInProgress}
        ></PDialog>
      )}
    </div>
  );
};
export default DayCloseDataEntry;
